module.exports = __webpack_public_path__ + "static/media/19_OTT_Invitationexample-02.0ba1c1d9.jpg";